import { getGroupPermissionFactory, PermissionEnum } from '../../../../common';
import { CountriesPermissions } from './countries.permissions';

export class CountryGeographicalZonesPermissions {
    static GroupName = `${CountriesPermissions.GroupName}.GeographicalZones`;

    static getPermissions = getGroupPermissionFactory(CountriesPermissions.GroupName);

    static Permissions = {
        ReadAll: CountryGeographicalZonesPermissions.getPermissions(PermissionEnum.READ_ALL),
    };
}
